import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import fetch from 'cross-fetch';
import { useLanguage, useAnalyticsAttributes, useAnalytics } from '../../components';
import { PlaceholderFrame, PlaceholderImage, PlaceholderText, Eyebrow, Title, Link, FallbackBanner } from './UiNavBlogArticle.styles';
import parseRss from './parseRss';
import { renderViewModel } from '../../render-view-model';
import { HeaderTabLink } from '../UiHeaderNav/shared';
export default function UiNavBlogArticle({ model: { id, type, content: { entryTitle, fallback, title, cta } }, isShowing = true, tabIndex }) {
    const feeds = {
        de: 'https://blog.trello.com/de/tag/anwendungsf%C3%A4lle/rss.xml',
        en: 'https://blog.trello.com/tag/use-cases/rss.xml',
        es: 'https://blog.trello.com/es/tag/ejemplos-de-uso/rss.xml',
        fr: 'https://blog.trello.com/fr/tag/id%C3%A9es-tableaux/rss.xml',
        pt: 'https://blog.trello.com/br/tag/exemplos-de-uso/rss.xml'
    };
    const [article, setArticle] = useState();
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    const lang = useLanguage().substring(0, 2);
    const [error, setError] = useState(false);
    const feed = feeds[lang];
    useEffect(() => {
        let cancelled = false;
        async function fetchArticle(feed) {
            try {
                const response = await fetch(feed);
                const text = await response.text();
                const article = parseRss(text);
                if (!cancelled) {
                    setArticle(article);
                }
            }
            catch (e) {
                console.error(e);
                if (!cancelled) {
                    setError(true);
                }
            }
        }
        if (isShowing && feed && !article && !error) {
            void fetchArticle(feed);
        }
        return () => {
            cancelled = true;
        };
    }, [feed, isShowing, article, error]);
    //lang is not supported or there's been an error, render fallback UiNavBanner
    if (!feed || error) {
        return _jsx(FallbackBanner, { children: renderViewModel(fallback) }, void 0);
    }
    //article is still loading, render placeholder skeleton
    if (!article) {
        return (_jsxs(PlaceholderFrame, Object.assign({ "data-testid": "ui-blog-article" }, { children: [_jsx(PlaceholderImage, {}, void 0), _jsx(Eyebrow, { children: _jsx(PlaceholderText, {}, void 0) }, void 0), _jsx(Title, { children: _jsx(PlaceholderText, {}, void 0) }, void 0)] }), void 0));
    }
    //render article loaded from RSS feed
    return (_jsxs(_Fragment, { children: [_jsx("h3", { children: title }, void 0), _jsxs(Link, Object.assign({ href: article.url, onClick: () => sendTrackEvent('clickedUiBlogArticle', Object.assign(Object.assign({}, analyticsAttributes), { event: 'clicked', eventComponent: type, href: article.url, label: article.title, labelEnglish: entryTitle, uuid: id })), tabIndex: tabIndex, target: "_blank", "data-testid": "ui-blog-article" }, { children: [article.imageUrl && _jsx("img", { src: article.imageUrl, alt: "" }, void 0), _jsx(Eyebrow, { children: article.eyebrow }, void 0), _jsx(Title, { children: article.title }, void 0)] }), void 0), cta.content && (_jsx(HeaderTabLink, { url: cta.content.url, text: cta.content.text, ariaLabel: cta.content.ariaLabel, onClick: () => sendTrackEvent('clickedGlobalNavSecondaryLink', Object.assign(Object.assign({}, analyticsAttributes), { event: 'clicked', eventComponent: 'globalNavSecondaryLink', label: cta.content.text, labelEnglish: cta.content.entryTitle, parentLabel: title, href: cta.content.url, uuid: cta.id })) }, void 0))] }, void 0));
}
//# sourceMappingURL=UiNavBlogArticle.js.map